import React from 'react';

const LoadingErrorState = ({ loading, error, onRetry }) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
        <p>{error}</p>
        <button 
          onClick={onRetry} 
          style={{ marginTop: '10px', padding: '8px 16px', cursor: 'pointer' }}
        >
          Retry
        </button>
      </div>
    );
  }

  return null;
};

export default LoadingErrorState;
